import React from "react";
import _ from "lodash";
import { showMedium } from "../../../api/media";
import FullPageSpinner from "../../FullPageSpinner";
import MediaTag from "../shared/MediaTag";

export default class PostPage extends React.Component {
  componentDidMount = async () => {
    let {
      data: { medium }
    } = await showMedium(this.props.match.params.id);
    this.setState({ medium });
  };
  state = { medium: null };
  mediumSetter = medium => this.setState({ medium });
  render() {
    return (
      <div className="m-4">
        {_.isNull(this.state.medium) ? (
          <FullPageSpinner />
        ) : _.isUndefined(this.state.medium) ? (
          <h1>I couldn't find what you are looking for</h1>
        ) : (
          <MediaTag
            showActions
            showProgress
            medium={this.state.medium}
            mediumSetter={this.mediumSetter}
          />
        )}
      </div>
    );
  }
}
